import { useEffect, useState, useCallback } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function useCollection(path) {
  const [items, setItems] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchItems = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${BACKEND_URL}/api/${path}`);
      setItems(res.data);
    } catch {
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, [path]);

  useEffect(() => { fetchItems(); }, [fetchItems]);
  return { items, loading, refresh: fetchItems };
}

export const useProducts = () => useCollection('products');
export const useTestimonials = () => useCollection('testimonials');
export const useGalleryPhotos = () => useCollection('gallery/photos');
export const useGalleryVideos = () => useCollection('gallery/videos');
